import styled from 'styled-components'

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    overflow: none;
    height: 100%;
`

export const Tabs = styled.div`
    flex-grow: 0;
`

export const Button = styled.button`
    /* flex: 1; */
`

export const List = styled.div`
    flex-grow: 1;
    overflow: auto;
    padding: 5px 0.5rem;

    svg {
        fill: #fff;

        g {
            stroke: #fff;
        }
    }
`
